import { forwardRef } from 'react';

export type PopoverArrowProps = {
  size: number;
  color: string;
};

export const PopoverArrow = forwardRef<HTMLDivElement, PopoverArrowProps>(
  function PopoverArrow({ size, color }, ref) {
    const placement = `-${size}px`;
    const arrowSize = size / 2;
    const containerSize = {
      vertical: {
        width: size * 2,
        height: size,
      },
      horizontal: {
        width: size,
        height: size * 2,
      },
    };

    return (
      <div
        ref={ref}
        data-testid='popover-arrow'
        css={{
          overflow: 'hidden',

          '&::before': {
            content: '""',
            position: 'absolute',
            width: size * 2,
            height: size * 2,
            borderRadius: size / 3,
            background: color,
            transform: 'rotate(45deg)',
          },

          '[data-popper-placement^="top"] > &': {
            bottom: placement,
            ...containerSize.vertical,
            '&::before': {
              bottom: arrowSize,
            },
          },

          '[data-popper-placement^="right"] > &': {
            left: placement,
            ...containerSize.horizontal,
            '&::before': {
              left: arrowSize,
            },
          },

          '[data-popper-placement^="bottom"] > &': {
            top: placement,
            ...containerSize.vertical,
            '&::before': {
              top: arrowSize,
            },
          },

          '[data-popper-placement^="left"] > &': {
            right: placement,
            ...containerSize.horizontal,
            '&::before': {
              right: arrowSize,
            },
          },
        }}
      />
    );
  },
);
